<!-- 申请意向回显 -->
<template>
  <div>
    <div style="background: #fff;padding-bottom:48px;">
      <div class="choose-intention"
           style="padding-bottom:0;">
        <div class="choose-intention-con">
          <p class="choose-intention-title">申请意向 - 选择原因</p>
          <div v-html="detail.chooseReason">{{detail.chooseReason}}</div>
        </div>
      </div>
      <div class="choose-intention"
           style="padding-bottom:0;">
        <div class="choose-intention-con">
          <p class="choose-intention-title">其它申请意向</p>
          <ul class="project-con">
            <li v-for="(item, index) in detail.otherPurpose"
                :key="index">
              <h1 class="title">项目 {{ ((index+1) < 10 ) ? ('0'+(index+1)) : (index+1) }}</h1>
              <div class="project-item">
                <p>学校名称</p>
                <div>{{item.univer}}</div>
              </div>
              <div class="project-item">
                <p>院校名称</p>
                <div>{{item.college}}</div>
              </div>
              <div class="project-item">
                <p>项目名称</p>
                <div>{{item.projectName}}</div>
              </div>
              <div class="project-item">
                <p>项目链接</p>
                <div>{{item.projectLink}}</div>
              </div>
              <div class="project-item">
                <p>申请原因</p>
                <div v-html="item.applyReason">
                  {{item.applyReason}}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { getPreviewItemAddFeedback, getSchemeItemAddFeedback } from '@/api/preproject'
// mixins
import mixinsPage from '@/view/mixins/page'
export default {
  name: '',
  props: ['type'],
  components: {},
  mixins: [mixinsPage],
  data () {
    return {
      id: this.$route.query.id,
      remarksModal: false,
      detail: {}
    }
  },
  computed: {},
  mounted () {
    this.getDetail()
  },
  methods: {
    getDetail () {
      let params = {
        sourceId: this.id
      }
      this.subData(params).then(res => {
        this.detail = res.data.model
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    subData (params) {
      return new Promise((resolve, reject) => {
        if (this.type === 'preview') {
          getPreviewItemAddFeedback(params).then(res => {
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        }
        if (this.type === 'scheme') {
          getSchemeItemAddFeedback(params).then(res => {
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
